module.exports = __webpack_public_path__ + "img/caravan-icon.8fbc3f0c.svg";